import { render, staticRenderFns } from "./TariffFeaturesCard.vue?vue&type=template&id=62cef730&scoped=true&"
import script from "./TariffFeaturesCard.vue?vue&type=script&lang=js&"
export * from "./TariffFeaturesCard.vue?vue&type=script&lang=js&"
import style0 from "./TariffFeaturesCard.vue?vue&type=style&index=0&id=62cef730&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cef730",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
